export default __webpack_public_path__ + "static/media/SG-Green-0005.2e0c9210.png";